const colors = {
  darkBlue: '#071924',
  white: '#f1f2f2',
  purple: '#58306f',
  purpleHover: '#5b4476',

  blue: '#0652dd',
  black: '#2c2a2a',
  grey: '#8c8c8c',
  lightGrey: '#e5e5e5',
  whiteGrey: '#f3f3f3',
  green: '#009432',
  red: '#ea2027',
  orange: '#ee5a24',
  yellow: '#ffc312',
  lightBlue: '#8BA3DB',
  darkRed: '#c11b21',
  lightRed: '#D89694',
};

const font = {
  textDescrSize: '18px',
  textTitleSize: '20px',
  smallSize: '18px',
  middleSize: '30px',
  bigSize: '35px',
};

const transition = {
  background: '10s ease',
  textHover: '0.2s ease',
  button: '0.2s ease',
};

const theme = { colors, font, transition };

export default theme;
